import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import { STEPPER_LIST_COUNTRY } from "../../../../constants/cms";
import { useParams } from "react-router-dom";
import {
  getCountryFaq,
  clearCountryFaq,
  putCountryFaq,
} from "../../../../../store/slices/country";
import { useDispatch, useSelector } from "react-redux";
import FaqsForm from "./faqsForm";
const Faqs = (props) => {
  const { id } = useParams();
  const [saveAndNext, setSaveAndNext] = useState(false);
  const user = useSelector((state) => state?.userData?.user?.data);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const dispatch = useDispatch();
  const { countryFaqData, putCountryFaqData } = useSelector(
    (state) => state.cmsCountry
  );
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getCountryFaq({ country_id: id }));
    }
    return () => {
      dispatch(clearCountryFaq());
    };
  }, [id]);

  useEffect(() => {
    if (putCountryFaqData) {
      if (saveAndNext) {
        window.location='/cms/country'
      }else{
        dispatch(getCountryFaq({ country_id: id }));
      }
      setSaveAndNext(false);
    }
  }, [putCountryFaqData]);

  useEffect(() => {
    if (countryFaqData) {
      let newvalues = {
        faq:
          countryFaqData.question_answer_list.length > 0
            ? countryFaqData.question_answer_list
            : [{ answer: "", question: "", status: false }],
        last_updated: countryFaqData.last_updated
          ? countryFaqData.last_updated
          : null,
        updated_by: countryFaqData.updated_by
          ? countryFaqData.updated_by
          : null,
      };
      setInitialValues(newvalues);
    }
  }, [countryFaqData]);
  const submit = (values) => {
    let data = {};
    data.question_answer_list = values?.faq;
    data.updated_by = user?.id;
    dispatch(putCountryFaq({ country_id: id }, data));
  };
  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper data={STEPPER_LIST_COUNTRY} activeStep={4} />
        </div>
      </div>
      <div>
        <FaqsForm
          submit={(e) => submit(e)}
          initialValues={initialValues}
          setSaveAndNext={setSaveAndNext}
          userPermission={userPermission}
        />
      </div>
    </div>
  );
};

export default Faqs;
